// src/contexts/StoreContext.jsx
import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import StoreService from "../services/store.service";

const StoreContext = createContext({ storeId: null, loading: false, error: null });

export const StoreProvider = ({ userId, isAuthenticated, children }) => {
  const [storeId, setStoreId] = useState(null);
  // INIT LOADING from props to avoid flash
  const [loading, setLoading] = useState(Boolean(isAuthenticated && userId));
  const [error, setError] = useState(null);
  const service = useMemo(() => new StoreService(), []);

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      setError(null);
      if (!isAuthenticated || !userId) {
        setStoreId(null);
        setLoading(false); // not fetching, not loading
        return;
      }
      setLoading(true);
      try {
        const id = await service.getStoreIdByUserId(userId);
        if (!cancelled) setStoreId(id);
      } catch (e) {
        if (!cancelled) setError(e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    run();
    return () => {
      cancelled = true;
    };
  }, [userId, isAuthenticated, service]);

  useEffect(() => {
    if (storeId) localStorage.setItem("storeId", storeId);
    else localStorage.removeItem("storeId");
  }, [storeId]);

  const value = useMemo(() => ({ storeId, loading, error }), [storeId, loading, error]);
  return <StoreContext.Provider value={value}>{children}</StoreContext.Provider>;
};

export const useStoreId = () => useContext(StoreContext).storeId;
export const useStoreState = () => useContext(StoreContext);
